module.exports = __webpack_public_path__ + "static/media/tidal.546f5309.svg";